import ReportedProblemModal from './ReportedProblemModal';

export default ReportedProblemModal;
